import React from 'react';
import { SVG } from '../../utils/types';

const HospitalIcon: React.FC<SVG> = ({
  width = 20,
  height = 20,
  color = '#72011E',
  otherProps,
  id = '',
}) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 5.20001V8.40002" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.6001 11.6H8.40006" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.6001 14.8H8.40006" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.6001 6.79993H8.40006" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.8 9.99992H16.4C16.8243 9.99992 17.2313 10.1685 17.5314 10.4686C17.8314 10.7686 18 11.1756 18 11.5999V16.3999C18 16.8243 17.8314 17.2313 17.5314 17.5313C17.2313 17.8314 16.8243 17.9999 16.4 17.9999H3.59997C3.17562 17.9999 2.76865 17.8314 2.46859 17.5313C2.16853 17.2313 1.99996 16.8243 1.99996 16.3999V9.19992C1.99996 8.77557 2.16853 8.3686 2.46859 8.06855C2.76865 7.76849 3.17562 7.59991 3.59997 7.59991H5.19997" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.7999 18V3.59994C14.7999 3.1756 14.6313 2.76863 14.3312 2.46857C14.0312 2.16851 13.6242 1.99994 13.1999 1.99994H6.79985C6.37551 1.99994 5.96854 2.16851 5.66848 2.46857C5.36842 2.76863 5.19985 3.1756 5.19985 3.59994V18" stroke={color} strokeWidth="1.44" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default HospitalIcon;